// extracted by mini-css-extract-plugin
export var cardIcon = "_ba-4";
export var checkboxCard = "_ba-0";
export var checkboxCardSelected = "_ba-3";
export var disabled = "_ba-1";
export var outerBorder = "_ba-2";
export var spacerMedium = "_ba-7";
export var spacerSmall = "_ba-6";
export var spacerXsmall = "_ba-5";